import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import parse from 'html-react-parser';

import Button from '../../../ui-core/Button/Button';
import { IMAGE_CONSTANT, TEXT_CONSTANT } from '../../../constants/app';

import './style.css';

const Features = props => {
  const featuresListOne = [
    {
      title: '6 Mobility Assessments',
      bodyPart: 'on the Foot/Ankle Complex',
    },
    {
      title: '2 Movement Assessments',
      bodyPart: 'on Gait and Squat Form',
    },
    {
      title: '4 Strength & Stability Assessments',
      bodyPart: 'for the Foot/Ankle Complex',
    },
  ];
  const featuresListTwo = [
    {
      title: '12 Mobility Exercises',
      bodyPart: 'to Set the Foot/Ankle Foundation',
    },
    {
      title: '4 Strength Exercises',
      bodyPart: 'to Improve Foot/Ankle Coordination & Control',
    },
    {
      title: '2 Full Foot/Ankle Flows',
      bodyPart: 'to Combine Exercises in One Place',
    },
  ];

  const handleClick = () => {
    if (props.onClick) {
      props.onClick(
        TEXT_CONSTANT.JOIN_NOW,
        'isSignup',
        TEXT_CONSTANT.WHAT_YOU_WILL_LEARN,
      );
    }
  };
  return (
    <div className="features-section-bare-foot">
      <h4>{TEXT_CONSTANT.WHAT_YOU_WILL_LEARN}</h4>
      <p className="feature-para">
        {parse(TEXT_CONSTANT.BARE_FOOT_MINI_COURSE)}
      </p>
      <Row>
        <Col>
          <ul>
            {featuresListOne.map(feature => (
              <li className="mb-4" key={feature.bodyPart}>
                <p className="bold">{feature.title}</p>
                <p>{feature.bodyPart}</p>
              </li>
            ))}
          </ul>
        </Col>
        <Col>
          <ul>
            {featuresListTwo.map(feature => (
              <li className="mb-4" key={feature.bodyPart}>
                <p className="bold">{feature.title}</p>
                <p>{feature.bodyPart}</p>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
      <div className="barefeet-tag d-flex align-items-center">
        <img
          alt="bare-feet"
          className="me-3"
          src={IMAGE_CONSTANT.bareFeetIcon}
        />
        <span className="font-weight-bold">
          {TEXT_CONSTANT.FEET_FOUNDATION}
        </span>
      </div>
      <div className="barefeet-ps">
        <p>{TEXT_CONSTANT.PAY_ATTENTION_TO_FEETS}</p>
        <p className="fs-bold feature-para">
          {TEXT_CONSTANT.DONT_MISS_OPPORTUNITY}
        </p>
      </div>
      <Button
        onClick={handleClick}
        text={TEXT_CONSTANT.JOIN_NOW}
        class="sign-up-button-new d-inline-block mx-auto mb-3"
      />
    </div>
  );
};

Features.propTypes = {
  onClick: PropTypes.func,
};

export default Features;
